import {
  ADD_SHIFT_URL,
  GET_WAREHOUSE_SHIFT,
  UPDATE_SHIFT_URL,
  UPLOAD_TOUR_FOR_SHIFT_URL,
  UPLOAD_TOUR_FOR_SHIFT_URL_V2,
} from "../../config/Url";

import { EVENT_TYPE, shiftMigrationTempWarhouseIds } from "../../config/constants";
import { IGetWarehouseShiftResponse } from "../../interfaces/shiftDetail.interface";
import { UPLOAD_CSV_TYPE } from "./../../config/constants";
import axios from "../../interceptors/axiosInterceptor";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";

export const getWarehouseShift = (warehouseId: string) =>
  new Promise<IGetWarehouseShiftResponse>((resolve, reject) => {
    const url = GET_WAREHOUSE_SHIFT.replace("{warehouse-id}", warehouseId);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data: IGetWarehouseShiftResponse = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const startShiftApiCall = (warehouseId: string) =>
  new Promise<IGetWarehouseShiftResponse>((resolve, reject) => {
    const url = ADD_SHIFT_URL.replace("{warehouse-id}", warehouseId);
    axios
      .post(url, {}, getAuthOptions())
      .then((response) => {
        if (response) {
          const data: IGetWarehouseShiftResponse = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updateShiftApiCall = (shiftId: string, eventType: EVENT_TYPE) =>
  new Promise<IGetWarehouseShiftResponse>((resolve, reject) => {
    const url = UPDATE_SHIFT_URL.replace("{shift-id}", shiftId).replace(
      "{event-type}",
      eventType
    );
    axios
      .post(url, {}, getAuthOptions())
      .then((response) => {
        if (response) {
          const data: IGetWarehouseShiftResponse = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const addTourCsvForShiftUploadApiCall = (
  url: string,
  payload: FormData,
) => new Promise<void>((resolve, reject) => {
    axios
      .post(url, payload, getAuthOptions(true))
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
